<template>
  <v-app>
    <header>
      <v-row class="btn-container" v-if="nowMissionChapter != 0">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="50"
          viewBox="0 0 50 50" @click="isOpenMenu = true" v-if="viewMenu == true && isOpenMenu == false">
          <image width="50" height="50"
            xlink:href="data:image/png;base64,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" />
        </svg>
      </v-row>

      <v-navigation-drawer v-model="isOpenMenu" class="navStyle" fixed temporary :right="true" width="200px">
        <v-row class="mt-5 mr-5">
          <v-col cols="12" class="text-right">
            <v-icon @click="isOpenMenu = false" class="viewText">mdi-close</v-icon>
          </v-col>
        </v-row>
        <v-list>

          <v-list-item to="/map">
            <v-list-item-content>
              <v-list-item-title class="viewText">エリアマップ</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/keyword">
            <v-list-item-content>
              <v-list-item-title class="viewText">キーワード</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/mission1" v-if="nowMissionChapter == 1 && nowMissionSection > 0 || nowMissionChapter > 1">
            <v-list-item-content>
              <v-list-item-title :class='[nowMissionChapter == 1 ? "nowText" : "viewText"]'>第１の謎
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/mission2" v-if="nowMissionChapter >= 2">
            <v-list-item-content>
              <v-list-item-title :class='[nowMissionChapter == 2 ? "nowText" : "viewText"]'>第２の謎
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/mission3" v-if="nowMissionChapter >= 3">
            <v-list-item-content>
              <v-list-item-title :class='[nowMissionChapter == 3 ? "nowText" : "viewText"]'>第３の謎
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/mission4" v-if="nowMissionChapter > 4 || (nowMissionChapter == 4)">
            <v-list-item-content>
              <v-list-item-title :class='[nowMissionChapter == 4 ? "nowText" : "viewText"]'>第４の謎
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/mission5" v-if="nowMissionChapter > 5 || (nowMissionChapter == 5)">
            <v-list-item-content>
              <v-list-item-title :class='[nowMissionChapter == 5 ? "nowText" : "viewText"]'>最終問題
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/present" v-if="nowMissionChapter >= 6">
            <v-list-item-content>
              <v-list-item-title class="viewText">クリア特典</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/ofuro">
            <v-list-item-content>
              <v-list-item-title class="viewText">貞子DXの湯</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/top">
            <v-list-item-content>
              <v-list-item-title class="viewText">TOP</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list>
        <div v-if="$store.getters.isMaintenance">
          <v-divider>
          </v-divider>
          <v-list>
            <v-list-item to="/maintenance">
              <v-list-item-icon>
                <v-icon color="red">mdi-cog</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="viewText">メンテナンス</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </v-navigation-drawer>
    </header>
    <v-main>
      <router-view />
    </v-main>
    <v-footer padless color="transparent">
      <v-col class="text-center pb-5 footer-copy" cols="12" style="font-size:12px;">
        &copy;2022『貞子DX』製作委員会
      </v-col>
    </v-footer>

  </v-app>
</template>
<style>

</style>
<style scoped>
.bgtop {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top;
}

.flashicon {
  animation: flash 1.5s infinite;
}

@keyframes flash {

  0%,
  100% {
    filter: drop-shadow(0 0 15px rgba(255, 255, 172, 0.8));
  }

  7%,
  93% {
    filter: drop-shadow(0 0 12px rgba(255, 255, 172, 0.75));
  }

  16%,
  84% {
    filter: drop-shadow(0 0 10px rgba(255, 255, 172, 0.67));
  }

  50% {
    filter: drop-shadow(0 0 10px rgba(255, 255, 172, 0)) opacity(80%);
    ;
  }
}

.viewText {
  color: #EBD8BA !important;
  font-size: 14px !important;
  font-family: "Helvetica Neue",
    Arial,
    "Hiragino Kaku Gothic ProN",
    "Hiragino Sans",
    Meiryo,
    sans-serif;
}

.nowText {
  color: #EBD8BA !important;
  font-size: 14px !important;
  font-weight: bold !important;
  font-family: "Helvetica Neue",
    Arial,
    "Hiragino Kaku Gothic ProN",
    "Hiragino Sans",
    Meiryo,
    sans-serif;
}
</style>
<script>
import axios from "axios";

export default {
  name: "App",

  data: () => ({
    isOpenMenu: false,
    viewMenu: true
    // nowMissionChapter: 9,
  }),
  created: async function () {
    this.$store.subscribe((mutation, state) => {
      // console.log("save local subscribe", mutation.type);
      if (!state.auth.lineUserHashKey && !state.auth.localUserHashKey) {
        // console.log("☆NO SET USER", state.auth);
        return;
      }

      if (["init", "setTos", "checkDevice", "setUserIds", "setMaintenance"].indexOf(mutation.type) == -1) {
        const saveData = {
          lineUserHashKey: state.auth.lineUserHashKey,
          nowMissionChapter: state.auth.nowMissionChapter,
          nowMissionSection: state.auth.nowMissionSection,
          hintPoints: state.auth.hintPoints,
          checkTos: state.auth.checkTos,
          recoverHintPointNum: state.auth.recoverHintPointNum,
          localUserHashKey: state.auth.localUserHashKey
        }

        // console.log("★★SaveServeData ", saveData);
        axios.post(
          process.env.VUE_APP_SERVER_SAVE_PATH + 'user',
          saveData)
          .then((res) => {
            // console.log("☆ServerRes", res);
          })
          .catch((error) => {
            console.error("☆ServerERROR", error);
          });
        localStorage.setItem(this.$store.getters.localStorageKey, JSON.stringify(saveData));

        gtag('event', 'progress', { 'event_category': this.nowMission, 'event_label': undefined });
      }
    });

    // 他のページが開いてたら強制移動
    if (!this.$store.getters.isLoad && this.nowPath != "/") {
      this.$router.push('/');
    }

  },
  methods: {

  },
  computed: {
    nowMissionChapter() {
      return this.$store.getters.nowMissionChapter;
    },
    nowMissionSection() {
      return this.$store.getters.nowMissionSection;
    },
    nowMission() {
      return this.$store.getters.nowMissionChapter + "-" + this.$store.getters.nowMissionSection;
    },
    nowPath() {
      return this.$route.path;
    }
  },
  watch: {
    nowPath(newVar) {
      let appDom = document.getElementById("app");
      switch (newVar) {
        case "/present":
        case "/ofuro":
        case "/mission1":
        case "/mission2":
        case "/mission3":
        case "/mission4":
        case "/mission5":
        case "/keyword":
          this.viewMenu = true;
          appDom.classList.add("defaultBg");
          break;
        case "/maintenance":
        case "/top":
        case "/missioninfo":
        case "/map":
          this.viewMenu = true;
          appDom.classList.remove("defaultBg");
          break;
        default:
          this.viewMenu = false;
          appDom.classList.add("defaultBg");
          break;
      }
    }
  }
};
</script>
